import React from "react"
import {twMerge} from "tailwind-merge"

export const CardHeadline: React.FC<{value: number}> = ({value}) => (
  <div
    className={"mt-[12px] text-[38px] leading-[1.05] font-extrabold tracking-[-1.4px] text-cr-slate-90 tabular-nums"}
  >
    {value.toLocaleString()}
  </div>
)

export type TStackSegment = {key: string; value: number; className: string}

export const StackBar: React.FC<{segments: readonly TStackSegment[]}> = ({segments}) => {
  const total = segments.reduce((sum, segment) => sum + Math.max(segment.value, 0), 0)

  return (
    <div aria-hidden className={"mt-[14px] flex h-[10px] overflow-hidden rounded-full bg-cr-slate-8"}>
      {total > 0 &&
        segments.map(segment => (
          <div
            key={segment.key}
            data-segment={segment.key}
            className={twMerge("h-full", segment.className)}
            style={{width: `${(Math.max(segment.value, 0) / total) * 100}%`}}
          />
        ))}
    </div>
  )
}

export type TStatItem = {key: string; label: string; value: number; dotClassName?: string}

export const StatRow: React.FC<{items: readonly TStatItem[]}> = ({items}) => (
  <dl className={"mt-[14px] flex flex-wrap gap-x-[26px] gap-y-3 border-t border-cr-slate-2 pt-[12px]"}>
    {items.map(item => (
      <div key={item.key} className={"flex flex-col-reverse"}>
        <dt className={"flex items-center gap-1.5 text-[11px] text-cr-slate-60"}>
          {item.dotClassName && <span aria-hidden className={twMerge("size-2 rounded-full", item.dotClassName)} />}
          {item.label}
        </dt>
        <dd className={"text-[19px] font-bold text-cr-slate-90 tabular-nums"}>{item.value.toLocaleString()}</dd>
      </div>
    ))}
  </dl>
)
